import { render, staticRenderFns } from "./RelatedProducts.vue?vue&type=template&id=35cbe85d&"
import script from "./RelatedProducts.vue?vue&type=script&lang=ts&"
export * from "./RelatedProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports